import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderService } from '../../orders/order.service';
import { ToasterService } from '../../toaster/toaster.service';
import { JsonPipe } from '@angular/common';
import { OrderEyeViewData } from '../../orders/models/OrderEyeViewData';
import { OrderDetailBoxComponent } from './components/order-detail-box/order-detail-box.component';
import { PalletDetailsBoxComponent } from './components/pallet-details-box/pallet-details-box.component';
import { ConsignorDetailsBoxComponent } from './components/consignor-details-box/consignor-details-box.component';
import { ConsigneeDetailsBoxComponent } from './components/consignee-details-box/consignee-details-box.component';

@Component({
  selector: 'app-order-eye-view-modal',
  standalone: true,
  imports: [JsonPipe, OrderDetailBoxComponent, PalletDetailsBoxComponent, ConsignorDetailsBoxComponent, ConsigneeDetailsBoxComponent],
  templateUrl: './order-eye-view-modal.component.html',
  styleUrl: './order-eye-view-modal.component.scss'
})
export class OrderEyeViewModalComponent implements OnChanges, OnInit {

  @Input()
  orderId: number | null = null;

  isLoading: boolean = false;
  orderView: OrderEyeViewData | null = null;

  constructor(protected activeModal: NgbActiveModal, private orderService: OrderService, private toasterService: ToasterService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['orderId']) {
      this.orderId = changes['orderId'].currentValue
      this.loadOrderDetails();
    }
  }

  ngOnInit(): void {
    this.loadOrderDetails();
  }

  loadOrderDetails() {
    this.isLoading = true;
    if (!this.orderId) {
      this.toasterService.show({
        text: 'No order id provided',
        classname: 'bg-danger text-light',
        delay: 5000
      });
      this.activeModal.dismiss();
    } else {
      this.orderService.getOrderEyeViewDetails(this.orderId).subscribe(order => {
        this.orderView = order;
        this.isLoading = false
      });
    }
  }

}
